var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnologyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1541_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z",
    fill: "#EE672F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0081 8.5L9.64062 12.7527V21.25L11.7447 22.4636L11.7311 13.9689L16.9941 10.9271L22.2575 13.9696V22.4609L24.3616 21.25V12.7457L17.0081 8.5ZM18.0533 22.4646L17.0011 23.0729L15.9456 22.4679V13.9696L13.8415 15.1831L13.8448 23.6778L17.0011 25.5L20.1554 23.6778V15.1831L18.0513 13.9696L18.0533 22.4646Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1541_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyImg);
export default __webpack_public_path__ + "static/media/technology-img.068fc4a3c98209eb7e8e3be6af763ce7.svg";
export { ForwardRef as ReactComponent };